import { useDispatch, useSelector } from 'react-redux';
import { useState, useCallback } from 'react';
import useNotification from '../notification/useNotification';
import { isSuccessResponse } from '../../common/utils';
import {
  ISinglewireUserState,
  singlewireToken,
} from './addSinglewireTokenSlice';
import { selector as singlewireTokenApi } from './addSinglewireTokenSlice';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { fetchSinglewireSiteData } from '../../pages/integrations/singlewire/listSinglewireSiteSlice';

interface ISinglewireTokenResponseState {
  singlewireTokenApi: ISinglewireUserState;
}

export const useAddSinglewireTokenModal = () => {
  const [token, setToken] = useState<string>('');
  const [showModel, setShowModel] = useState<boolean>(false);

  const dispatch: ThunkDispatch<
    ISinglewireTokenResponseState,
    undefined,
    Action
  > = useDispatch();
  const singlewireTokenResponse = useSelector(singlewireTokenApi);
  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  const handleAddButtonClick = useCallback(() => {
    dispatch(singlewireToken({ singlewireToken: token })).then(
      (response: any) => {
        if (isSuccessResponse(response.payload)) {
          dispatch(fetchSinglewireSiteData());
          showSuccessNotification(response.payload.message);
        } else {
          showWarningNotification(response.payload.response.data.message);
        }
      }
    );
    setShowModel(false);
  }, [token]);

  return {
    handleAddButtonClick,
    showModel,
    handleShow,
    handleClose,
    setToken,
    singlewireTokenResponse,
    token,
  };
};
